module.exports = __webpack_public_path__ + "img/@logo_jkl@3x.0c34dd2e.png";